import { render, staticRenderFns } from "./Contant-us.vue?vue&type=template&id=2623464d&"
import script from "./Contant-us.vue?vue&type=script&lang=js&"
export * from "./Contant-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports